import { AnimatePresence, motion } from 'framer-motion';
import { cn } from '@/lib/cn';

export type ToastTone = 'success' | 'error' | 'warning';

const tones: Record<ToastTone, string> = {
  success: 'bg-state-success-soft text-state-success',
  error: 'bg-state-danger-soft text-state-danger',
  warning: 'bg-state-warning-soft text-state-warning',
};

const icons: Record<ToastTone, string> = {
  success: '✓',
  error: '⚠',
  warning: '⚠',
};

export type ToastData = { id: string; tone: ToastTone; message: string };

export function ToastViewport({ toasts }: { toasts: ToastData[] }) {
  return (
    <div className="pointer-events-none fixed inset-x-0 top-24 z-50 flex flex-col items-center gap-2 px-6">
      <AnimatePresence>
        {toasts.map((t) => (
          <motion.div
            key={t.id}
            initial={{ opacity: 0, y: -16 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -16 }}
            role="status"
            className={cn(
              'flex w-full max-w-md items-center gap-3 rounded-card px-5 py-4 text-base font-semibold shadow-lg',
              tones[t.tone],
            )}
          >
            <span aria-hidden className="text-xl">
              {icons[t.tone]}
            </span>
            {t.message}
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
}
